import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const ClockSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 41 41' fill='none'>
    <path
      d='M20.4997 37.1667C29.7044 37.1667 37.1663 29.7047 37.1663 20.5C37.1663 11.2953 29.7044 3.83333 20.4997 3.83333C11.2949 3.83333 3.83301 11.2953 3.83301 20.5C3.83301 29.7047 11.2949 37.1667 20.4997 37.1667Z'
      stroke='#F39C12'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20.5 10.5V20.5L27.1667 23.8333'
      stroke='#F39C12'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const ClockIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ClockSvg} {...props} />
);
